import React from "react";

const LongTextEdit = ({
  rows,
  html,
  item,
  longTextEditHandler,
  showLongTextHandler,
  isLongText,
}) => {
  return (
    <div className="long_text_long_long">
      <div
        class="new-inline-edit-edit"
        onClick={() => longTextEditHandler(item)}
      >
        <div>
          <i class="fa fa-pencil" aria-hidden="true"></i>
        </div>
      </div>
      <p>
        <span
          dangerouslySetInnerHTML={{
            __html: html,
          }}
          className="longtextbug"
        ></span>
        &nbsp;
        <span
          onClick={() => showLongTextHandler(item)}
          style={{
            color: "#18A0FB",
            cursor: "pointer",
          }}
        >
          {isLongText?.[item.field]?.long ? (
            <strong>Show less</strong>
          ) : (
            rows[item.field].length > 400 && <strong>Show more</strong>
          )}
        </span>
      </p>
    </div>
  );
};

export default LongTextEdit;
